import { render, staticRenderFns } from "./SearchList.vue?vue&type=template&id=160045ec&scoped=true"
import script from "./SearchList.vue?vue&type=script&lang=js"
export * from "./SearchList.vue?vue&type=script&lang=js"
import style0 from "./SearchList.vue?vue&type=style&index=0&id=160045ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160045ec",
  null
  
)

export default component.exports